const state = {
  showSecondary: false,
  pages: [],
  activePageId: null,
  pageCounter: 0,
  secondaryPageVisible: false,
};

const mutations = {
  OPEN_PAGE(state, payload) {
    const id = `page_${state.pageCounter++}`;

    state.pages.push({
      id,
      component: payload.component,
      title: payload.title,
      props: payload.props || {},
    });

    state.activePageId = id;
    state.showSecondary = true;
  },

  OPEN_SUB_PAGE(state, payload) {
    const parentName = payload.parentName;
    const page = state.pages.find((p) => p.component.name === parentName);
    const opened = state.pages.find(
      (p) => p.component === payload.currentComponent && p.parentId === page.id
    );
    if (opened) {
      state.activePageId = opened.id;
      return;
    }

    const id = `page_${state.pageCounter++}`;
    state.pages.push({
      parentId: page.id,
      id,
      component: payload.currentComponent,
      selectedIndex: payload.selectedIndex,
      title: payload.title,
      props: payload.props || {},
    });

    state.activePageId = id;
    state.showSecondary = true;
  },

  CLOSE_PAGE(state, id) {
    const index = state.pages.findIndex((p) => p.id === id);
    if (index === -1) return;
    state.pages.splice(index, 1);
    if (id === state.activePageId) {
      if (state.pages.length > 0) {
        const newIndex = Math.min(index, state.pages.length - 1);
        state.activePageId = state.pages[newIndex].id;
      } else {
        state.activePageId = null;
        state.showSecondary = false;
      }
    }
  },

  SWITCH_PAGE(state, id) {
    state.activePageId = id;
  },
  CLEAR_PAGES(state) {
    state.pages = [];
    state.activePageId = null;
    state.showSecondary = false;
  },

  setSecondaryPageVisible(state, visible) {
    state.secondaryPageVisible = visible;
  },
};

const actions = {
  openPage({ commit }, payload) {
    commit("OPEN_PAGE", payload);
  },
  openSubPage({ commit }, payload) {
    commit("OPEN_SUB_PAGE", payload);
  },

  closePage({ commit }, id) {
    commit("CLOSE_PAGE", id);
  },

  switchPage({ commit }, id) {
    commit("SWITCH_PAGE", id);
  },
  clearPages({ commit }) {
    commit("CLEAR_PAGES");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
